import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { settingsStoreToken } from '../../../../../../../cross-team-shared/state/setting-state';
import { SettingsService } from '../../../../../../h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { zoomPanelIcon } from '../../../../../../shared/icons/toolbars/zoom-panel-icon';
import { RootKeyboardShortcutService } from '../../../../../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';

@Component({
  selector: 'h3-toggle-zoom-panel',
  templateUrl: './toggle-zoom-panel.component.html',
  styleUrl: './toggle-zoom-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleZoomPanelComponent {
  private readonly settingsService = inject(SettingsService);
  private readonly shortcutService = inject(RootKeyboardShortcutService);
  isZoomPanelOpened$ = inject(settingsStoreToken)('zoomPanel')('isOpen').$;
  tooltipText =
    'Zoom panel' + this.shortcutService.tooltipSuffix('toggleZoomPanel');
  zoomPanelIcon = zoomPanelIcon;

  toggleZoomPanel() {
    this.settingsService.toggleZoomPanel('button');
  }
}
